'use strict';

angular.module('imagetrend.components')
    .directive('hlpFormBuilderComponentConditions', [function () {
        return {
            restrict: 'AE',
            scope: {
                component: '=?',
                form: '=?',
                isDisabled: '=?'
            },
            controller: ['$scope', 'ApplicationTypes', '$injector', '$filter', function ($scope, ApplicationTypes, $injector, $filter) {
                $scope.$watchGroup(['form', 'component'], function (newValues, oldValues) {
                    var form = newValues[0];
                    var conditionalComponent = newValues[1];

                    if (form != null && conditionalComponent != null) {
                        $scope.questions = [];
                        var hitComponent = false;

                        form.pages.forEach(function (page) {
                            if (!hitComponent) {
                                page.sections.forEach(function (section) {
                                    if (!hitComponent) {
                                        section.components.forEach(function (component) {
                                            hitComponent = $scope.getComponentQuestion(component, hitComponent, conditionalComponent, section, page);
                                        })
                                    }
                                })
                            }
                        })

                        $scope.component.component_conditions.forEach(function (condition) {
                            $scope.questionChange($filter('filter')($scope.questions, { id: condition.question_id })[0], condition, true);
                        })
                    }
                })
                
                $scope.getComponentQuestion = function (component, hitComponent, conditionalComponent, section, page) {
                    if (component.id == conditionalComponent.id) {
                        hitComponent = true;
                    }

                    if (!hitComponent) {
                        if (component.questions != null) {
                            component.questions.forEach(function (question) {
                                question.group = page.name + ': ' + section.name;
                                $scope.questions.unshift(question);

                                if (!hitComponent) {
                                    if (question.sub_components == null) {
                                        question.sub_components = [];
                                    }

                                    question.sub_components.forEach(function (subComponent) {
                                        hitComponent = $scope.getComponentQuestion(subComponent, hitComponent, conditionalComponent, section, page);
                                    })
                                }
                            })
                        }
                    }

                    return hitComponent;
                }

                $scope.getComponentFromID = function (componentID) {
                    var result = null;

                    if ($scope.form != null) {
                        $scope.form.pages.forEach(function (page) {
                            if (result == null) {
                                page.sections.forEach(function (section) {
                                    if (result == null) {
                                        section.components.forEach(function (component) {
                                            if (component.id == componentID) {
                                                result = component;
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                    return result;
                }

                $scope.andOrOptions = [
                    { id: true, name: 'and' },
                    { id: false, name: 'or' }
                ];
                $scope.leftParenOptions = [
                    { id: 0, name: '' },
                    { id: 1, name: '(' },
                    { id: 2, name: '((' }
                ];
                $scope.rightParenOptions = [
                    { id: 0, name: '' },
                    { id: 1, name: ')' },
                    { id: 2, name: '))' }
                ];
                $scope.dateOptions = [
                    { id: 0, name: 'Reference Date' },
                    { id: 1, name: 'Days From Today' },
                    { id: 2, name: 'Months From Today' }
                ];

                $scope.questionChange = function (question, condition, initial) {
                    condition.loading = true;
                    if (question != null) {
                        if (question.question_type.code == 'date') {
                            condition.operators = [
                                { id: '=', name: '=' },
                                { id: '<>', name: '<>' },
                                { id: '>', name: '>' },
                                { id: '<', name: '<' }
                            ];
                            if (condition.date_option > 0) {
                                condition.value = parseInt(condition.value);
                                if (isNaN(condition.value)) {
                                    condition.value = null;
                                }
                            }
                        }
                        else {
                            condition.operators = [
                                { id: '=', name: '=' },
                                { id: '<>', name: '<>' }
                            ];
                        }

                        condition.options = [];
                        condition.selectValue = 'id';
                        condition.selectShow = 'name';
                        condition.question_type = question.question_type.code;

                        if (!initial) {
                            condition.value = null;
                        }

                        if (question.question_type.code == 'yesno') {
                            condition.options = [
                                    { id: true, name: 'Yes' },
                                    { id: false, name: 'No' }
                            ];
                            condition.loading = false;
                        }
                        else if (question.service != null) {
                            var service = $injector.get(question.service);
                            if (question.method == null) {
                                question.method = 'get';
                            }
                            var arg = {};
                            if (question.service == 'LicenseCategoryLevels' || question.service == 'LicenseCategoryCertificationStatuses') {
                                //Get the license category of the component question
                                var component = $scope.getComponentFromID(question.component_id);
                                if (component) {
                                    arg.license_category_id = component.license_category_id;
                                }
                                //Pass along the license_id in case the license is the same license category
                                if ($scope.component.parameters) {
                                    arg.current_license_id = $scope.component.parameters.license_id || $scope.component.parameters.orignalLicenseID;
                                }
                            }
                            service[question.method](arg).then(function (data) { //data_section_name is being set as parameter dynamically based on question.method 
                                condition.options = data;
                                condition.loading = false;
                            });
                        }
                        else if (question.question_type.code == 'application_type') {
                            //Application type will always be the same license category as the current license, so only need to pass along the license_id
                            var parameters = {};
                            if ($scope.component.parameters) {
                                parameters.license_id = $scope.component.parameters.license_id || $scope.component.parameters.orignalLicenseID;
                            }
                            ApplicationTypes.get(parameters).then(function (types) {
                                types.forEach(function (type) {
                                    condition.options.push({ id: type.id, name: type.label || type.name });
                                });
                                condition.loading = false;
                            });
                        }
                        else if (question.options != null){
                            if (angular.isString(question.options)) {
                                question.options.split(',').forEach(function (value) {
                                    condition.options.push({ id: value.trim(), name: value.trim() });
                                })
                            }
                            else{
                                condition.options = question.options;
                            }

                            condition.loading = false;
                        }
                        else {
                            condition.loading = false;
                        }
                    }
                    else {
                        condition.loading = false;
                    }
                }

                $scope.add = function (array, order) {
                    array.push({ and_flag: true, left_parenthesis: 0, operator: '=', right_parenthesis: 0, sort_order: order });
                }

                $scope.remove = function (array, item) {
                    array.splice(array.indexOf(item), 1);
                }
            }],
            replace: true,
            transclude: true,
            templateUrl: 'templates/form-builder/form-builder-component-conditions/form-builder-component-conditions.html',
            link: function (scope, elem, attrs, ctrl) {
                
            }
        };
    }])
;